
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "refreshActivities",
      resolverType: "mutation",
      routePath: "/refreshActivities",
      httpMethod: "POST",
    });
  